import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/propriedade' };
/////////////////////////////////////////////////////////////////////////////////

export function createFazendaCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateFazendaCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listFazendaCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findFazendaCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllFazendaCadastro() {
  return httpService.get({ ...args, path: '/propriedade/all' });
}

export function deleteFazendaCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function verificarLicenca() {
  return httpService.get({ ...args, path: '/licenca/isBloq/' });
}
